<style>
 
.form-control-feedback {
 top: 33px;
  font-size: 18px;
  position: absolute;
  right: 7px;
  cursor: pointer;  
}
 
</style>
<template>
  <div class="body" id="body">
    <br />
    <notifications group="notify" position="top center"  />
    <div class="container">
      <div class="row justify-content-center">
         
        <div class="col-lg-4 col-md-6 col-sm-6" style="margin-top: 20px;">
              <img src="/images/logo.png" style="max-width: 71%;padding: 27px;margin-left: 34px;" alt="">               
  
          <div class="card card-color card-login">
            <div class="card-body">
               
              <form @submit="checkForm">
                <div class="form-group has-feedback">
                  <label for="email" class="control-label"></label>
                  <input type="text" class="form-control" v-model="payload.login" autocomplete="off" placeholder="login" /> 
                </div>
                <div class="form-group has-feedback">
                  <label for="senha" class="control-label"></label>
                  <input  :type="senha" v-model="payload.senha"   class="form-control"  autocomplete="off"  placeholder="senha"  />
                   
                </div>
                <br />
                <button type="submit" :disabled="disabledLogin==1" class="btn btn-outline-primary float-right" >Entrar</button>
              </form>
            </div>
          </div>
 
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {AdminService} from "@/http"

import {Login} from "@/soganhei"

 
export default {
  name: "Login",
  components: {},
  data: () => {
    return {
      disabled: 0,
      disabledLogin: 0, 
      senha: "password",
      visualizarSenha: true,      
      payload:Login, 
     };
  },
  methods: {
     checkForm(e){
       
        e.preventDefault();

        this.disabledLogin = 0
        const payload = Object.assign({},this.payload)       

        AdminService.LoginAdmin(payload).then(response=>{
 
          this.$cookies.set(process.env.VUE_APP_TOKEN_ADMIN,response.data)
          this.$router.push({name:"adminMotoristas"});


        }).catch(error=>{
            
            window.console.warn(error)
             this.$notify({
              group: "notify",
              text: "Usuário não encontrado",
              type: "error"
            });
        })
       
         
      }, 
  }, 
   
};
</script>


 
